/* eslint-disable no-undef */
import React from 'react';
import { motion } from 'framer-motion';
import ContactUsForm from './ContactUsForm';
import BoxedContainer from '../layouts/BoxedContainer';
import ContactUsDetails from './ContactUsDetails';

export default function ContactDetailsForm({ data, id }) {
  return (
    <motion.section
      id={!data.text.includes("Summer League") ? id : 'contact'}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className={`contact-form w-full bg-white
      ${data.title.includes("sponsor") 
      ? '' 
      : `clip-right-top lg:-mt-20 -mt-[20px] lg:pt-[190px] pt-[80px] z-20 relative`}

      ${data.text.includes("Summer League") 
        ? `clip-left-bottom lg:-mb-20 -mb-[20px] relative z-5` 
        : ''}

        `}
    >
      <BoxedContainer className="regular">
        <div
          className="flex lg:flex-row flex-col 2xl:gap-x-[130px] gap-x-[60px] lg:gap-y-0
        gap-y-[60px] lg:pb-[170px] pb-[90px]"
        >
          <ContactUsForm data={data} />
          {!data.text.includes("Summer League") ? <ContactUsDetails data={data} /> : ''}
        </div>
      </BoxedContainer>
    </motion.section>
  );
}
